export const environment = {
  production: false,
  TOKEN_URL: 'https://herop-api-staging.azurewebsites.net/api/identity/v1/auth/token',
  REFRESH_URL: 'https://herop-api-staging.azurewebsites.net/api/identity/v1/auth/refreshToken',
  BASE_URL: 'https://herop-api-staging.azurewebsites.net',
  API_URL: 'api',
  DEFAULT_LANGUAGE: 'it-IT',
  APP_NAME: 'Sales',
  ENV: 'Staging',
};


